module.exports = __webpack_public_path__ + "img/logo-dark.f8bd1711.png";